import React, {useContext} from 'react';
import styled from "styled-components";
import {FilterContext} from "@providers/filters";
import RadiusGenerate from "@helpers/radius.generate";
import ConvertPixelToRem from "@helpers/convert.rem";
import ButtonTransparent from "@atoms/button.transparent";
import Badges from "@atoms/badges";
import Icon from "@atoms/icon";
import ChevronLeftIcon from "@icons/chevron-left.svg";

export function MoreFilterBtn({className, setModalFiltersShow, selectedFiltersCount}) {
    const {more} = useContext(FilterContext);
    const {show} = more;

    return (
        <More show={show} className={(typeof className !== "undefined" ? className : '')}>
            <MoreFilterButton className={"d-flex align-items-center " + (selectedFiltersCount > 0 ? ' selected pr-16 pl-8' : '')} onClick={() => setModalFiltersShow(true)}>
                بیشتر

                {
                    (selectedFiltersCount > 0) ?
                        <Badges color="primary" className="mr-8" circle>{selectedFiltersCount}</Badges>
                        :
                        <Icon className="mr-8"><ChevronLeftIcon/></Icon>
                }
            </MoreFilterButton>
        </More>
    )
}

// styles

const More = styled.div`
    display: none;
    
    @media (min-width: ${props => props.theme.screenXsMax}) {
        display: ${props => props.show ? 'block' : 'none'};
    }
`;

const MoreFilterButton = styled(ButtonTransparent)`
    height: 35px;
    color: ${props => props.theme.black};
    font-size: ${ConvertPixelToRem(14)};
    font-weight: 400;
    border: 1px solid ${props => props.theme.gray300};
    padding: 0 16px;
    ${RadiusGenerate('50px')};
    
    &:hover {
        border-color: ${props => props.theme.black};
        font-weight: 400;
    }
    
    .icons svg {
        width: 10px;
        height: 10px;
    }
    
    &.selected {
        border: solid 1.5px rgb(22,6,71);
        background-color: rgb(235,247,255);
    }
`;